export default __webpack_public_path__ + "static/media/CL11.2.7ec0a7a4.mp3";